export default "__VITE_ASSET__39h8VgYf__"